/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { Icons, colors, size } from '@everlywell/leaves';
import styled from 'styled-components';

interface ChipWrapperProps {
  wrap: number | null;
}

const ChipWrapper = styled.button<ChipWrapperProps>`
  display: flex;
  justify-content: space-between;
  font-size: 16px;
  font-weight: bold;
  line-height: 1.5;
  letter-spacing: 0.46px;
  padding: 6px 36px 6px ${size.sm}px;
  border: none;
  position: relative;
  cursor: pointer;
  background-color: ${colors.green1};
  text-transform: uppercase;
  color: ${colors.green5};
`;

const CloseBtn = styled(Icons.Close)`
  position: absolute;
  top: 11px;
  right: ${size.sm}px;
  height: 14px;
  width: 14px;
`;

export { ChipWrapper, CloseBtn };
